import { toTitleCase } from '../../lib/toTitleCase';

export interface GeneralAddress {
  gatabox?: string;
  postnr: string;
  postort: string;
}

interface ForetagAdressProps<T> {
  address: T;
}

export const ForetagAdress = <T extends GeneralAddress>({
  address,
}: ForetagAdressProps<T>) => (
  <div>
    {address.gatabox && (
      <>
        {toTitleCase(address.gatabox)} <br />
      </>
    )}
    {(address.postnr || address.postort) &&
      `${address.postnr} ${toTitleCase(address.postort)}`}
  </div>
);
